
export { useReCaptcha } from "/opt/atlassian/pipelines/agent/build/packages/modules/module-core/src/captcha/use-recaptcha.ts"